// extracted by mini-css-extract-plugin
export default {"btnBox":"contactBtn_btnBox__AwL8+","iconContentAlign":"contactBtn_iconContentAlign__9vv0b","btnsBlock":"contactBtn_btnsBlock__FISiy"};